import Select, { StylesConfig } from "react-select";

// * Custom styles for the react-select dropdown component which is used in the add/edit people and add/edit group form

// const customStyles: StylesConfig<any, boolean> = {
//     control: (provided) => ({
//       ...provided,
//       borderRadius: 0,
//       borderColor: '#ccc',
//       boxShadow: 'none',
//     }),
//     menu: (provided) => ({
//       ...provided,
//       borderRadius: 0,
//     }),
//     option: (provided, state) => ({
//       ...provided,
//       borderRadius: 0,
//     }),
//   };

// const customStyles: StylesConfig<any, boolean> = {
//   control: (provided, state) => ({
//     ...provided,
//     borderRadius: 0,
//     borderColor: '#ccc',
//     boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none', // Slight change on focus for better UX
//     '&:hover': {
//       borderColor: '#2684FF', // Changes border color on hover
//     },
//   }),
//   menu: (provided) => ({
//     ...provided,
//     borderRadius: 0,
//   }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected ? '#2684FF' : '#fff',
//     color: state.isSelected ? '#fff' : '#333',
//     '&:hover': {
//       backgroundColor: '#f1f1f1', // Changes background color on hover
//     },
//     borderRadius: 0,
//   }),
//   multiValue: (provided) => ({
//     ...provided,
//     backgroundColor: '#e4e4e4',
//   }),
//   multiValueLabel: (provided) => ({
//     ...provided,
//     color: '#333',
//   }),
//   multiValueRemove: (provided) => ({
//     ...provided,
//     color: '#666',
//     ':hover': {
//       backgroundColor: '#FF5630',
//       color: 'white',
//     },
//   }),
// };

const customStyles: StylesConfig<any, boolean> = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: 0,
    borderColor: "#ccc", // Default border color
    boxShadow: state.isFocused ? "0 0 0 1px #ccc" : "none", // Keep border color grey on focus
    "&:hover": {
      borderColor: "#ccc", // Grey border color on hover
      boxShadow: "none", // Remove box shadow on hover
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#2684FF"
      : state.isFocused
      ? "#f1f1f1"
      : "#fff", // Grey background on hover
    color: state.isSelected ? "#fff" : "#333",
    "&:hover": {
      backgroundColor: "#f1f1f1", // Greyish background color on hover
    },
    borderRadius: 0,
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: "#e4e4e4",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "#333",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "#666",
    ":hover": {
      backgroundColor: "#FF5630",
      color: "white",
    },
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: "#ccc", // Color of the dropdown indicator arrow
    "&:hover": {
      color: "#333", // Change color on hover (same as in customStyles)
    },
  }),
};


// const addGalleryDropdownStyle: StylesConfig<any, boolean> = {
//   control: (provided, state) => ({
//     ...provided,
//     borderRadius: 0,
//     borderColor: "rgb(103, 104, 105)", // Default border color
//     boxShadow: state.isFocused ? "0 0 0 1px #ccc" : "none", // Keep border color grey on focus
//     "&:hover": {
//       borderColor: "#ccc", // Grey border color on hover
//       boxShadow: "none", // Remove box shadow on hover
//     },
//   }),
//   menu: (provided) => ({
//     ...provided,
//     borderRadius: 0,
//   }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? "#2684FF"
//       : state.isFocused
//       ? "#f1f1f1"
//       : "#fff", // Grey background on hover
//     color: state.isSelected ? "#fff" : "#333",
//     "&:hover": {
//       backgroundColor: "#f1f1f1", // Greyish background color on hover
//     },
//     borderRadius: 0,
//   }),
//   multiValue: (provided) => ({
//     ...provided,
//     backgroundColor: "#e4e4e4",
//   }),
//   multiValueLabel: (provided) => ({
//     ...provided,
//     color: "#333",
//   }),
//   multiValueRemove: (provided) => ({
//     ...provided,
//     color: "#666",
//     ":hover": {
//       backgroundColor: "#FF5630",
//       color: "white",
//     },
//   }),
//   dropdownIndicator: (provided, state) => ({
//     ...provided,
//     color: "#ccc", // Color of the dropdown indicator arrow
//     "&:hover": {
//       color: "#333", // Change color on hover (same as in customStyles)
//     },
//   }),
// };

const customSingleSelectStyles: StylesConfig<any, boolean> = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: 0,
    borderColor: "#ccc", // Default border color
    boxShadow: state.isFocused ? "0 0 0 1px #ccc" : "none", // Keep border color grey on focus
    "&:hover": {
      borderColor: "#ccc", // Grey border color on hover
      boxShadow: "none", // Remove box shadow on hover
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor:  state.isDisabled
    ? "#f1f1f1" 
    : state.isSelected
    ? "#e3e3e3"
    : state.isFocused
    ? "#f1f1f1"
    : "#fff",
    // color: state.isSelected ? "#fff" : "#333",
    color: "#333",
    "&:hover": {
      backgroundColor: "#f1f1f1", // Greyish background color on hover
      color: state.isSelected ?  "#000" : "#333",
    },
    borderRadius: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333", // Text color for selected value
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#999", // Placeholder text color
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "#ccc", // Color of the indicator separator line
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: "#ccc", // Color of the dropdown indicator arrow
    "&:hover": {
      color: "#333", // Change color on hover (same as in customStyles)
    },
  }),
};

const addGalleryDropdownStyle: StylesConfig<any, boolean> = {
  control: (provided, state) => ({
    ...provided,
    borderRadius: 0,
    borderColor: "rgb(103, 104, 105)", // Default border color
    boxShadow: state.isFocused ? "0 0 0 1px #ccc" : "none", // Keep border color grey on focus
    "&:hover": {
      boxShadow: "none", // Remove box shadow on hover
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#e3e3e3"
      : state.isFocused
      ? "#f1f1f1"
      : "#fff", // Grey background on hover
    // color: state.isSelected ? "#fff" : "#333",
    color: "#333",
    "&:hover": {
      backgroundColor: "#f1f1f1", // Greyish background color on hover
      color: state.isSelected ?  "#000" : "#333",
    },
    borderRadius: 0,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#333", // Text color for selected value
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#999", // Placeholder text color
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "#ccc", // Color of the indicator separator line
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: "#ccc", // Color of the dropdown indicator arrow
    "&:hover": {
      color: "#333", // Change color on hover (same as in customStyles)
    },
  }),
};

export  { customStyles, customSingleSelectStyles, addGalleryDropdownStyle };
